<template>
  <div id="hres8ax-deduction-tab1" class="panel box-collapse border-color-skin">
   <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#deduction-tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>รายการลดหย่อน
      </h3>
    </div>

    <div id="deduction-tab1" class="panel-collapse collapse tab-detailDeduction">
      <div class="panel-body">{{flgEdit}}
         <hrms-table :columns="detailDeductionTable1" 
                      :data="detailDeduction" 
                      :searchDisp="false"
                      :rowDisableCondition="rowDisableCondition"
                      :editInlineEventBool="true"
                      :saveInlineBtnDisp="false" />  

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres8ax-deduction-tab1',
  props: [
    'labels',
    'detailDeduction',
    'detailDeductionTable1'
  ],
  methods: {
    rowDisableCondition (dataRow) {
      return dataRow.amtdisable === 'N'
    }
  }
}
</script>


// WEBPACK FOOTER //
// deduction_1.vue?b722f5da